import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { searchReturnTo } from '../../components/searchReturnTo';
import { useFeatureFlag } from '../../featureFlags/useFeatureFlag';
import { HRDashBoard } from '../../modules/ComponentsLibrary/HRDashboard';
import { hrDashboardTabsIds } from '../../modules/ComponentsLibrary/HRDashboard/constants';
import { STEP_PARAMS } from '../../modules/PerformanceReviews/model/nextStep';
import { ReviewPage } from '../../modules/PerformanceReviews/ReviewPage';

export const Route = createFileRoute('/hrDashboard/$prId')({
  component: RouteComponent,
  params: z.object({
    prId: z.coerce.number().positive(),
  }),
  validateSearch: z.object({
    defaultTabId: z.enum(hrDashboardTabsIds).optional(),
    step: z.enum(STEP_PARAMS).optional().catch(undefined),
    from: searchReturnTo,
  }),
  head(ctx) {
    return {
      meta: [{ title: 'HR Dashboard' }],
    };
  },
});

function RouteComponent() {
  const redesign = useFeatureFlag('performance-reviews.redesign', { scope: 'page' });
  const params = Route.useParams();
  const searchParams = Route.useSearch();
  if (redesign) {
    return (
      <ReviewPage
        key={params.prId}
        prId={params.prId}
        step={searchParams.step}
        from={searchParams.from}
      />
    );
  }
  return <HRDashBoard prId={params.prId} defaultTabId={searchParams.defaultTabId || '0'} />;
}
